import { User } from 'prg-core-lib';

export class UserProfile extends User {}
